import styles from './EmailStatus.css'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'

class EmailStatus extends React.Component {
  render () {
    if (this.props.confirmed) {
      const tooltip = <Tooltip>Email is verified</Tooltip>
      return <OverlayTrigger overlay={tooltip} placement='top'>
        <span className={`fa fa-check-circle ${styles.confirmed}`} />
      </OverlayTrigger>
    } else {
      const tooltip = <Tooltip>Resend Invitation</Tooltip>
      return <OverlayTrigger overlay={tooltip} placement='top'>
        <button className={`btn btn-xs btn-primary no-padding ${styles.resend}`}
          onClick={this._onClickResend}>
          <img src={require('./ic-resend.svg')} height='20px' />
        </button>
      </OverlayTrigger>
    }
  }

  _onClickResend = (e) => {
    e.stopPropagation()
    this.props.onClickResendInvitation({email: this.props.email})
  }
}

EmailStatus.propTypes = {
  confirmed: React.PropTypes.bool,
  email: React.PropTypes.string,
  onClickResendInvitation: React.PropTypes.func
}
export default EmailStatus



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffList/EmailStatus/EmailStatus.js